<template>
	<div id="productImages">
		<div class="productImageContainer" :style="{height: imageHeight + 'px'}">
			<ProductSticker :stickerId="stickerId" />
			<img
				v-if="currentImage"
				id="drift"
				@load="loaded"
				class="main-image"
				:class="{'lightbox': currentImage.original != null}"
				:src="imageUrl(currentImage, imageToShow)"
				:data-zoom="imageUrl(currentImage, 'original')"
				:href="imageUrl(currentImage, 'original')"
				:alt="productName"
			>
		</div>
	</div>
</template>

<script>
import Drift from "drift-zoom";
import { Luminous } from "luminous-lightbox";

import PinchZoom from "pinch-zoom-js";
import { imageUrl } from "@/utils";
import ProductSticker from "@/components/ProductSticker"

export default {
	name: "productImages",
	components: {
		ProductSticker
	},
	data: () => {
		return {
			currentImageIndex: 0,
			driftInstance: null,
			imageHeight: 200
		};
	},
	props: ["images", "productName", "stickerId"], //images array of images
	computed: {
		currentImage() {
			let defaultImage = "/resources/images/content/default-image-large-2.png"
			if (!this.images) return null;
			return this.images[this.currentImageIndex].sizes || defaultImage;
			},
			imageToShow(){
			if (this.currentImage.original) {
				return 'original'
			} else{
				return 'medium'
			}
		},
	},
	//must be on mounted so that the correct DOM elements exist for drift
	mounted() {
		if (!this.currentImage) return;

		if(this.currentImage.original){ //only do it on images with large size present
		// https://github.com/imgix/drift
		// Zoom on hover on desktop
		this.driftInstance = new Drift(document.querySelector("#drift"), {
			paneContainer: document.querySelector(".zoomContainer"),
			// inlineContainer: document.querySelector(".productImages"),
			zoomFactor: 3,
			// paneContainer: document.body,
			// When to switch to an inline ZoomPane. This can be a boolean or
			// an integer. If `true`, the ZoomPane will always be inline,
			// if `false`, it will switch to inline when `windowWidth <= inlinePane`
			inlinePane: false, //375,
			// containInline: false,
			injectBaseStyles: false,
			hoverBoundingBox: false,
		});

		//lightbox
		this.luminousInstance = new Luminous(document.querySelector(".lightbox"), {
			injectBaseStyles: false
		});

		}
	},
	methods: {
		imageUrl: imageUrl,
		loaded(event) {
		const imgHeight = event.target.clientHeight;
		this.imageHeight = imgHeight;

		//delayed so that it occurs after image height is set
		setTimeout(() => {
			// https://github.com/manuelstofer/pinchzoom
			this.pzoom = new PinchZoom(document.querySelector("#drift"), {
				draggableUnzoomed: false
			});
		}, 10);
		}
	}
};
</script>

<style lang="scss" scoped>
.productImageContainer {
	position: relative;
}

.productImageContainer, .main-image{
	max-width: 1200px;
}

.lightbox {
	cursor: zoom-in;
}

img.selected {
	border: black 1px solid;
}

#zoom-container {
	border: 1px black solid;
}
</style>

<style lang="scss">
.lum-lightbox {
	cursor: zoom-out;
}

// pane that zoomed image appreas in on hover
.drift-zoom-pane {
	position:absolute;
	top:0;
	bottom:0;
	z-index:20;
	border: 1px solid black;
	// border-radius: 20px;
	max-width: 96%;
	max-height: 400px;
	overflow:hidden;
	img{
		height:auto;
		width:auto;
	}
}

// TODO make this match mobile breakpoint
@include media-breakpoint-down(md) {
	//hide hover zoom on mobile
	.drift-zoom-pane.drift-open,
	.drift-zoom-pane {
		display: none;
	}

	//prevent hover events on mobile
	#drift {
		pointer-events: none;
	}
	.stockIcon {
		z-index: 999;
		width: 80px;
		height: 80px;
	}
}
</style>
